import NavBar from './navbar';
import EmptyBar from './emptybar';
import { Outlet } from 'react-router-dom';

const Layout = ({ emptyBar = false }) => (
  <>
    {emptyBar ? <EmptyBar /> : <NavBar />}
    <Outlet />
  </>
);

export default Layout;